// extracted by mini-css-extract-plugin
export default {"card":"InfoPage_card__EvdMM","content":"InfoPage_content__oCQhh","heading":"InfoPage_heading__Cz4PN","footer":"InfoPage_footer__AStge"};